import * as React from "react";

export default function Fee({
  className,
  viewBox = "0 0 17 16",
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M6.76688 5.41784C6.92167 5.31464 7.11289 5.2224 7.3335 5.15101L7.3335 6.84899C7.11289 6.7776 6.92167 6.68536 6.76688 6.58216C6.40277 6.33942 6.3335 6.1139 6.3335 6C6.3335 5.8861 6.40277 5.66058 6.76688 5.41784Z"
        fill="currentColor"
      />
      <path
        d="M9.33351 10.849L9.33351 9.15101C9.55412 9.2224 9.74533 9.31464 9.90013 9.41784C10.2642 9.66058 10.3335 9.8861 10.3335 10C10.3335 10.1139 10.2642 10.3394 9.90014 10.5822C9.74534 10.6854 9.55412 10.7776 9.33351 10.849Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.3335 16C12.7518 16 16.3335 12.4183 16.3335 8C16.3335 3.58172 12.7518 0 8.3335 0C3.91522 0 0.333496 3.58172 0.333496 8C0.333496 12.4183 3.91522 16 8.3335 16ZM9.3335 3C9.3335 2.44772 8.88578 2 8.3335 2C7.78121 2 7.3335 2.44772 7.3335 3V3.09199C6.7119 3.20873 6.13697 3.43407 5.65748 3.75374C4.9358 4.23485 4.3335 5.00933 4.3335 6C4.3335 6.99067 4.9358 7.76515 5.65748 8.24626C6.13698 8.56593 6.71191 8.79128 7.33351 8.90801L7.33351 10.8492C6.94251 10.7223 6.65267 10.5319 6.49016 10.3446C6.12821 9.92748 5.49663 9.88274 5.07949 10.2447C4.66234 10.6067 4.61761 11.2382 4.97956 11.6554C5.54205 12.3036 6.39305 12.7308 7.3335 12.9076L7.3335 13C7.33348 13.5523 7.78119 14 8.33348 14C8.88576 14 9.33348 13.5523 9.3335 13L9.3335 12.908C9.9551 12.7913 10.53 12.5659 11.0095 12.2463C11.7312 11.7651 12.3335 10.9907 12.3335 10C12.3335 9.00933 11.7312 8.23485 11.0095 7.75373C10.53 7.43407 9.9551 7.20873 9.3335 7.09199L9.3335 5.15075C9.7245 5.27771 10.0143 5.4681 10.1768 5.65538C10.5388 6.07252 11.1704 6.11726 11.5875 5.7553C12.0047 5.39335 12.0494 4.76176 11.6875 4.34462C11.125 3.69637 10.274 3.26915 9.3335 3.09236V3Z"
        fill="currentColor"
      />
    </svg>
  );
}
